import AV from 'leancloud-storage'

AV.init({
  serverURLs: {
    api: 'https://avoscloud.com'
  },
  appId: 'GjKJoYYJzugLC2A2cuTqPtkl-gzGzoHsz',
  appKey: 'iFDyLIwtRRIiV0ETsNAtAy7x'
})

window.AV = AV

export default AV
